import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
type Category = 'Uñas' | 'Cuidado Capilar';
type MediaItem = {
  id: number;
  src: string;
  category: Category;
  alt: string;
  type: 'image' | 'video';
};
const galleryImages: MediaItem[] = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/cGNUTWbxL5eKcMmzWpP7LZ/SaveClip.App_437397338_18055254424583633_9019986794113456431_n.jpg',
  category: 'Uñas',
  alt: 'Uñas esculpidas french con perlas',
  type: 'image'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/uJsj9iT2KNhMCU1sbRB3YC/SaveClip.App_441889776_18060585640583633_966029425272454033_n.jpg',
  category: 'Uñas',
  alt: 'Uñas ombré violeta con strass',
  type: 'image'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/mqWuTKozjEXTev3mxH5h2P/SaveClip.App_629363662_18120943408583633_8511108107480122871_n.jpg',
  category: 'Uñas',
  alt: 'Uñas con diseño floral 3D naranja',
  type: 'image'
}, {
  id: 7,
  src: 'https://cdn.magicpatterns.com/uploads/fforLzCCjwr3RkxnhdHSKy/SaveClip.App_632073423_18541963123064686_4340094134168883937_n.jpg',
  category: 'Uñas',
  alt: 'Uñas nude con strass',
  type: 'image'
}, {
  id: 8,
  src: 'https://cdn.magicpatterns.com/uploads/niDYWFm5wT1V5VYBsjJbck/SaveClip.App_437397338_18055254424583633_9019986794113456431_n.jpg',
  category: 'Uñas',
  alt: 'Uñas esculpidas french con perlas',
  type: 'image'
}, {
  id: 9,
  src: 'https://cdn.magicpatterns.com/uploads/rxhUWy9a649KPkxB5bS52z/SaveClip.App_449596036_18063398560583633_2220660093812355473_n.jpg',
  category: 'Uñas',
  alt: 'Uñas color bordó con diseño abstracto',
  type: 'image'
}, {
  id: 10,
  src: 'https://cdn.magicpatterns.com/uploads/e3dCZr2TtrpxahHsfz4mLv/SaveClip.App_471534757_18080627320583633_4167360762735809594_n.jpg',
  category: 'Uñas',
  alt: 'Uñas rosa con glitter y strass',
  type: 'image'
}, {
  id: 11,
  src: 'https://cdn.magicpatterns.com/uploads/faxcYHWrmpqWLmiHzc3nHV/SaveClip.App_584180686_18112760197583633_7531275816916940852_n.jpg',
  category: 'Uñas',
  alt: 'Uñas con diseño floral sobre base clara',
  type: 'image'
}, {
  id: 12,
  src: 'https://cdn.magicpatterns.com/uploads/xhmou8qugz4sdVKsXjYu9K/SaveClip.App_628179926_18120308566583633_3445770631170051303_n.jpg',
  category: 'Uñas',
  alt: 'Uñas ombré rosa y naranja',
  type: 'image'
}, {
  id: 13,
  src: 'https://cdn.magicpatterns.com/uploads/dEEtANhGgrEDuHJJ3m3JDb/SaveClip.App_AQNFr7LIytjdnCHK2K2lnDIpnvw60URVecxllbFvcM9nD46hOu64_qy_krelYRH9P61oF9FzF21dlTkK8nYnnaD7AGEFFq14_COcEW0.mp4',
  category: 'Cuidado Capilar',
  alt: 'Cuidado capilar video 1',
  type: 'video'
}, {
  id: 14,
  src: 'https://cdn.magicpatterns.com/uploads/hhnyqvfMPvA6bLYQzYq4fF/SaveClip.App_AQNoNmxDz1Od2Lylpl5-5592DEqLy-NRalFhlcqTsZjsB2u-MVdfldcXhX3TwysdoexziqphJGTCOYcbg5Kq91KA_VTKRdG2cQ-rA7Y.mp4',
  category: 'Cuidado Capilar',
  alt: 'Cuidado capilar video 2',
  type: 'video'
}, {
  id: 15,
  src: 'https://cdn.magicpatterns.com/uploads/oa2B1v3bAWbxmkGerbZJtm/SaveClip.App_AQNUX8zLOErA7ykguRMRyTsgDmoAxe9cZXkrAnybIcncEPqaAp0yowM9QbbO-ju-Xovakt2DV7QaiPl98RwNsgH6Tbq62FX5sXKJgVw.mp4',
  category: 'Cuidado Capilar',
  alt: 'Cuidado capilar video 3',
  type: 'video'
}, {
  id: 16,
  src: 'https://cdn.magicpatterns.com/uploads/qW3hr25Dzxi9fjMdsizgZh/SaveClip.App_AQOAR6R9fElZp9X_72c0lbtBdjORCk25yU41b2zmC-mnnB13DCtb7W_9mWM_FwlMIArtkD5SxcJemAwNQsNqeD0bxH0ZZ_hn6DIsbOo.mp4',
  category: 'Cuidado Capilar',
  alt: 'Cuidado capilar video 4',
  type: 'video'
}, {
  id: 17,
  src: 'https://cdn.magicpatterns.com/uploads/4dczCBMtWgxcy4JmYi6emG/SaveClip.App_AQPsJJKsd-24-s3dogH7OozeBmDp_-9j8Aq6nRB1qX1Fq7mMZBpa8X5mKr4W6pN6iWHhE14iMgXYKmSMxDp5KDWSj3lp4mxCPHpFy10.mp4',
  category: 'Cuidado Capilar',
  alt: 'Cuidado capilar video 5',
  type: 'video'
}];
export function Gallery() {
  const [filter, setFilter] = useState<Category>('Uñas');
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const filteredImages = galleryImages.filter(img => img.category === filter);
  // Lightbox handlers
  const openLightbox = (index: number) => setSelectedImageIndex(index);
  const closeLightbox = () => setSelectedImageIndex(null);
  const showNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((selectedImageIndex + 1) % filteredImages.length);
    }
  };
  const showPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((selectedImageIndex - 1 + filteredImages.length) % filteredImages.length);
    }
  };
  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (selectedImageIndex === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') setSelectedImageIndex((selectedImageIndex + 1) % filteredImages.length);
      if (e.key === 'ArrowLeft') setSelectedImageIndex((selectedImageIndex - 1 + filteredImages.length) % filteredImages.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImageIndex, filteredImages.length]);
  return <section id="galeria" className="py-24 bg-white" data-id="element-127">
      <div className="container mx-auto px-6 md:px-12" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-brand-mocha mb-8" data-id="element-130">
            Nuestros Trabajos
          </motion.h2>

          {/* Filters */}
          <div className="flex justify-center gap-2 md:gap-4 overflow-x-auto pb-4 scrollbar-hide" data-id="element-131">
            {(['Uñas', 'Cuidado Capilar'] as Category[]).map(cat => <button key={cat} onClick={() => setFilter(cat)} className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${filter === cat ? 'bg-brand-mocha text-white shadow-md' : 'bg-brand-cream text-brand-mocha hover:bg-brand-mocha/10'}`} data-id="element-132">
                {cat}
              </button>)}
          </div>
        </div>

        {/* Masonry Grid */}
        <motion.div layout className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-133">
          <AnimatePresence data-id="element-134">
            {filteredImages.map((img, index) => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={img.id} className="break-inside-avoid relative group cursor-pointer overflow-hidden rounded-xl" onClick={() => openLightbox(index)} data-id="element-135">
                {img.type === 'video' ? <video src={img.src} autoPlay loop muted playsInline className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-136" /> : <img src={img.src} alt={img.alt} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-137" />}
                <div className="absolute inset-0 bg-brand-mocha/0 group-hover:bg-brand-mocha/20 transition-colors duration-300" data-id="element-138" />
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-139">
        {selectedImageIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-brand-mocha/95 backdrop-blur-sm p-4" onClick={closeLightbox} data-id="element-140">
            <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors" onClick={closeLightbox} data-id="element-141">
              <X size={32} data-id="element-142" />
            </button>

            <button className="absolute left-4 md:left-12 top-1/2 -translate-y-1/2 text-white/70 hover:text-white p-2 transition-colors" onClick={showPrev} data-id="element-143">
              <ChevronLeft size={40} data-id="element-144" />
            </button>

            {filteredImages[selectedImageIndex].type === 'video' ? <motion.video key={selectedImageIndex} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} src={filteredImages[selectedImageIndex].src} autoPlay loop muted playsInline className="max-w-full max-h-[85vh] object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-145" /> : <motion.img key={selectedImageIndex} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} src={filteredImages[selectedImageIndex].src} alt={filteredImages[selectedImageIndex].alt} className="max-w-full max-h-[85vh] object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-146" />}

            <button className="absolute right-4 md:right-12 top-1/2 -translate-y-1/2 text-white/70 hover:text-white p-2 transition-colors" onClick={showNext} data-id="element-147">
              <ChevronRight size={40} data-id="element-148" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </section>;
}